module.exports = __webpack_public_path__ + "img/sheetSet.96276b93.svg";